export function getChunkStatusLabel(chunk) {
    const isSuccess =
        chunk.httpStatus !== null &&
        chunk.httpStatus >= 200 &&
        chunk.httpStatus < 300;
    const failedItems = chunk.items.filter((it) => it.isError);

    if (chunk.httpStatus === null) return 'Pending';
    if (!isSuccess) return 'Error';
    if (failedItems.length === 0) return 'OK';
    if (failedItems.length === chunk.items.length) return 'Error';
    return 'Partial';
}
